import React, { useEffect, useState, useRef } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { withRouter, Link, useLocation } from "react-router-dom"
import { isEmpty, set } from "lodash"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import cellEditFactory from "react-bootstrap-table2-editor"
import * as Yup from "yup"
import { useFormik } from "formik"
// import makeAnimated from "react-select/animated";
// import DeleteModal from "../../../components/Common/DeleteModal";

import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import * as moment from "moment"

import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Badge,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Table,
  CardTitle,
  InputGroup,
} from "reactstrap"

//redux
import { useSelector, useDispatch } from "react-redux"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

import {
  getVectors as onGetVectors,
  addNewVector as onAddNewVector,
  updateVector as onUpdateVector,
  deleteVector as onDeleteVector,
  getAuthUsers as onGetAuthUser,
} from "store/actions"

import VectorsOrdersModal from "./VectorOrdersModal"
import Columns from "./Columns"
import { expandRow } from "./vectorDetails"
import OffCanvasModel from "components/OrdersOffCanvas/offCanvas"
import Filter from "components/Common/filterComponentForCustomers"
import FilterComponent from "components/Common/filterComponentForCustomers"

const VectorsOrders = props => {
  const dispatch = useDispatch()
  const location = useLocation()
  const [orderList, setVectorList] = useState([])
  const [order, setVector] = useState(null)

  const [path, setPath] = useState(location)

  useEffect(() => {
    setPath(location.pathname)
  }, [location])

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      orderId: (order && order.orderId) || "",
      billingName: (order && order.billingName) || "",
      orderdate: (order && order.orderdate) || "",
      total: (order && order.total) || "",
      paymentStatus: (order && order.paymentStatus) || "Paid",
      badgeclass: (order && order.badgeclass) || "success",
      paymentMethod: (order && order.paymentMethod) || "Mastercard",
    },
    validationSchema: Yup.object({
      orderId: Yup.string().required("Please Enter Your Vector Id"),
      billingName: Yup.string().required("Please Enter Your Billing Name"),
      orderdate: Yup.string().required("Please Enter Your Vector Date"),
      total: Yup.string().required("Total Amount"),
      paymentStatus: Yup.string().required("Please Enter Your Payment Status"),
      badgeclass: Yup.string().required("Please Enter Your Badge Class"),
      paymentMethod: Yup.string().required("Please Enter Your Payment Method"),
    }),
    onSubmit: values => {
      if (isEdit) {
        const updateVector = {
          id: order ? order.id : 0,
          orderId: values.orderId,
          billingName: values.billingName,
          orderdate: values.orderdate,
          total: values.total,
          paymentStatus: values.paymentStatus,
          paymentMethod: values.paymentMethod,
          badgeclass: values.badgeclass,
        }
        // update order
        dispatch(onUpdateVector(updateVector))
        validation.resetForm()
      } else {
        const newVector = {
          id: Math.floor(Math.random() * (30 - 20)) + 20,
          orderId: values["orderId"],
          billingName: values["billingName"],
          orderdate: values["orderdate"],
          total: values["total"],
          paymentStatus: values["paymentStatus"],
          paymentMethod: values["paymentMethod"],
          badgeclass: values["badgeclass"],
        }
        // save new order
        dispatch(onAddNewVector(newVector))
        validation.resetForm()
      }
      toggle()
    },
  })

  const { vectors, designerUsers } = useSelector(state => ({
    vectors: state.Vectors.vectors,
    designerUsers: state.Vectors.auth,
  }))

  const selectRow = {
    mode: "checkbox",
  }

  const [modal, setModal] = useState(false)
  const [modal1, setModal1] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [isRight, setIsRight] = useState(false)
  const [designers, setDesigners] = useState({})
  const [pageOptions, setPageOptions] = useState({
    sizePerPage: 50,
    page: 1,
    totalSize: 50,
    custom: true,
  })

  const handleTableChange = (type, { page, sizePerPage }) => {
    let json = {
      params: { requestFor: "vector" },
      paginate: { size: 50, page: page },
    }
    dispatch(onGetVectors(json))
  }

  const handleFilterClick = (name,number,status, date) => {
    let json = {
      params: { requestFor: "vector"},
      paginate: { size: 50, page: 1 },
    }
    name ? json.params.orderName = name :"";
    status ? json.params.orderStatus = status: "";
    number ? json.params.orderCode = number : "";
    date ? json.params.submitDateTime= {$gte: date[0], $lte: date[1]} : "";
    dispatch(onGetVectors(json))
  }

  const { SearchBar } = Search

  const toggleViewModal = () => setModal1(!modal1)

  const toLowerCase1 = str => {
    return str === "" || str === undefined ? "" : str.toLowerCase()
  }

  useEffect(() => {
    if (!vectors.hasOwnProperty("docs")) {
      let json = {
        params: { requestFor: "vector" },
        paginate: { size: 50, page: 1 },
      }
      dispatch(onGetVectors(json))
    }
  }, [dispatch, vectors])

  useEffect(() => {
    if (!designerUsers.hasOwnProperty("docs")) {
      dispatch(onGetAuthUser())
    }

    setDesigners(designerUsers)
  }, [dispatch, designerUsers])

  useEffect(() => {
    setVectorList(vectors)
    setPageOptions({
      sizePerPage: vectors.limit,
      page: vectors.offset,
      totalSize: vectors.totalDocs,
      custom: true,
    })
  }, [vectors])

  useEffect(() => {
    if (!isEmpty(vectors) && !!isEdit) {
      setVectorList(vectors)
      setIsEdit(false)
    }
  }, [vectors])

  const toggle = () => {
    if (modal) {
      setModal(false)
      setVector(null)
    } else {
      setModal(true)
    }
  }

  const handleVectorClick = arg => {
    const order = arg

    setVector({
      id: order.id,
      orderId: order.orderId,
      billingName: order.billingName,
      orderdate: order.orderdate,
      total: order.total,
      paymentStatus: order.paymentStatus,
      paymentMethod: order.paymentMethod,
      badgeclass: order.badgeclass,
    })

    setIsEdit(true)

    toggle()
  }

  var node = useRef()
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page)
    }
  }

  //delete order
  const [deleteModal, setDeleteModal] = useState(false)

  const onClickDelete = order => {
    // setVector(order)
    // setDeleteModal(true)
    dispatch(onDeleteVector(order._id))
  }

  const handleValidDate = date => {
    const date1 = moment(new Date(date)).format("DD MMM Y")
    return date1
  }

  const toggleRightCanvas = () => {
    setIsRight(!isRight)
  }

  const defaultSorted = [
    {
      dataField: "orderId",
      order: "desc",
    },
  ]
  const handleChange = (oldValue, newValue, row, column, done) => {
    if (column.dataField === "assTo") {
      dispatch(onUpdateVector(row))
    } else {
      dispatch(onUpdateVector(row))
    }
  }

  return (
    <React.Fragment>
      {/* <OffCanvasModel isRight={isRight} toggleRightCanvas={toggleRightCanvas} /> */}
      <VectorsOrdersModal isOpen={modal1} toggle={toggleViewModal} />
      {/* <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteVector}
        onCloseClick={() => setDeleteModal(false)}
      /> */}
      <div className="page-content">
        <MetaTags>
          <title>Vectors</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Vectors" breadcrumbItem="Vectors" />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField="_id"
                    columns={Columns(
                      toggle,
                      handleValidDate,
                      handleVectorClick,
                      onClickDelete,
                      toLowerCase1,
                      toggleViewModal,
                      designers,
                      path
                    )}
                    data={
                      vectors.hasOwnProperty("docs") ? vectors.docs : vectors
                    }
                    // cellEdit={ cellEditFactory({ mode: 'click' }) }
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="_id"
                        data={
                          vectors.hasOwnProperty("docs")
                            ? vectors.docs
                            : vectors
                        }
                        columns={Columns(
                          toggle,
                          handleValidDate,
                          handleVectorClick,
                          onClickDelete,
                          toLowerCase1,
                          toggleViewModal,
                          designers,
                          path
                        )}
                        bootstrap4
                        search
                        // cellEdit={ cellEditFactory({ mode: 'click' }) }
                      >
                        {toolkitProps => (
                          <React.Fragment>
                            {/* <Row> */}
                            <Col sm="12">
                             <FilterComponent handleFilterClick={handleFilterClick} />
                            </Col>
                            {/* </Row> */}
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                                  <BootstrapTable
                                    remote={{
                                      filter: true,
                                      pagination: true,
                                      sort: false,
                                      cellEdit: false,
                                    }}
                                    keyField="_id"
                                    responsive
                                    bordered={false}
                                    striped={false}
                                    defaultSorted={defaultSorted}
                                    selectRow={selectRow}
                                    classes={
                                      "table align-middle table-nowrap table-check"
                                    }
                                    headerWrapperClasses={"table-light"}
                                    {...toolkitProps.baseProps}
                                    {...paginationTableProps}
                                    onTableChange={handleTableChange}
                                    cellEdit={cellEditFactory({
                                      mode: "dbclick",
                                      blurToSave: true,
                                      afterSaveCell: handleChange,
                                    })}
                                    expandRow={expandRow}
                                    ref={node}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row className="align-items-md-center mt-30">
                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </Col>
                            </Row>
                          </React.Fragment>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

VectorsOrders.propTypes = {
  orders: PropTypes.array,
  onGetVectors: PropTypes.func,
  onAddNewVector: PropTypes.func,
  onDeleteVector: PropTypes.func,
  onUpdateVector: PropTypes.func,
}

export default withRouter(VectorsOrders)
